import type { FC } from 'react';

import {
  ErrorPage,
  type ErrorPageProps,
} from '#packages/web/layouts/page/templates';
import { Message } from '#packages/web/foundations/feedback/message';

export type FatalErrorProps = ErrorPageProps & {
  /**
   * The error that occurred.
   */
  error: Error;
};

export const FatalError: FC<FatalErrorProps> = ({ error, ...props }) => (
  <ErrorPage
    message={[
      <Message key={1}>An unexpected fatal error occurred</Message>,
      <Message key={2}>{error.message}</Message>,
    ]}
    {...props}
  />
);
